export const CURRENT_TERMS_VERSION = '2026-07-11'
export const TERMS_OF_USE_PATH = '/terms-of-use'
export const PRIVACY_POLICY_PATH = '/privacy-policy'
